<template>
  <div>
    <v-container>
      <v-layout wrap row avatar>
        <v-flex xs3 sm2 class="pa-2" style="position: relative">
          <v-icon
            v-if="adjust_qty && adjust_qty > 0"
            color="primary"
            style="position: absolute; z-index: 2; left: 10px; top: 10px"
            >mdi-cart</v-icon
          >
          <v-img
            :src="
              product && product.photourl
                ? typeof product.photourl == 'string' &&
                  product.photourl.split(';;').length
                  ? product.photourl.split(';;')[0]
                  : product.photourl[0]
                : ''
            "
            :alt="product.name"
            :lazy-src="require(`@/assets/img/products/default-photo.png`)"
            lazy
            aspect-ratio="1"
            class="grey lighten-2"
          ></v-img>
        </v-flex>

        <v-flex xs7 sm8 class="pl-2 pr-2 pt-2">
          <!-- <v-list-tile-title
            style="cursor: pointer"
            :style="{ color: theme.color }"
            @click="$emit('showProduct', product.id)"
            >{{ product.name }}</v-list-tile-title
          > -->
          <v-list-tile-title
            style="cursor: pointer"
            :style="{ color: theme.color }"
            @click="$emit('showProduct', product)"
            >{{ product.name }}</v-list-tile-title
          >

          <div>
            <template v-if="product.option">({{ product.option }})</template>
          </div>
          <div class="" v-if="product.addon_json">
            <template
              v-if="
                pageProfile.type == 'reka' &&
                product.addon_json &&
                product.addon_json.embroideredNameList &&
                product.addon_json.embroideredNameList.length > 0
              "
            >
              <template
                v-for="(item, index) in product.addon_json.embroideredNameList"
              >
                <div class="warning--text" :key="index">
                  ปักชื่อ ({{ index + 1 }}) +฿100:<br />
                  <nl2br tag="span" :text="item" />
                  <v-icon
                    small
                    class="ml-2"
                    :color="theme.color"
                    @click="deleteEmbroideredNameList(index)"
                    >close</v-icon
                  >
                </div>
              </template>
            </template>
          </div>
          <div class="warning--text" v-if="product.cart_remark">
            {{ $t('Remark') }}: {{ product.cart_remark }}
          </div>

          <template v-if="['nestle'].includes(pageProfile.type)">
            <CheckBundle :product="product" class="my-2" />
          </template>
          <v-list-tile-sub-title>
            <p class="price">
              <template v-if="product.bundleprice">
                <span
                  class="discount"
                  style="margin-right: 5px"
                  v-if="
                    product.price * product.quantity !== product.bundleprice
                  "
                  >{{ currencySign
                  }}{{
                    (product.price * product.quantity) | decimalFormat
                  }}</span
                >
                {{ currencySign }}{{ product.bundleprice | decimalFormat }}
              </template>
              <template v-else>
                <span
                  v-if="
                    product.discountprice != null &&
                    product.discountprice != product.price
                  "
                  class="discount"
                  style="margin-right: 5px"
                  >{{ currencySign
                  }}{{
                    (product.price * product.quantity) | decimalFormat
                  }}</span
                >
                {{ currencySign
                }}{{
                  ((product.discountprice != null &&
                  product.discountprice != product.price
                    ? product.discountprice
                    : product.price) *
                    product.quantity)
                    | decimalFormat
                }}
              </template>
            </p>
            <!-- <div v-if="!isOutOfStock"> -->
            <template v-if="product.categoryid == 10625">x</template>
            <v-btn
              v-if="product.categoryid != 10625 && !viewTransferPage"
              small
              fab
              outline
              :color="theme.color"
              @click="checkAdjustRemoveCount()"
              :disabled="
                loading == true ||
                (isCDS && category.name == 'Limit Order 1 Piece') ||
                quantity == 1 ||
                (isYasale && quantity <= minimumQuantity)
              "
              class="ma-0 pa-0 mt-2 mb-2"
            >
              <v-icon>mdi-minus</v-icon>
            </v-btn>

            <span
              style="
                width: 30px;
                display: inline-block;
                margin-left: 5px;
                margin-right: 5px;
                text-align: center;
              "
              >{{ quantity }}</span
            >

            <template v-if="currentStock">
              <v-btn
                v-if="product.categoryid != 10625 && !viewTransferPage"
                small
                fab
                outline
                :color="theme.color"
                @click="checkAdjustAddCount()"
                :disabled="
                  quantity >=
                    parseInt(currentStock[2]) + parseInt(adjust_qty) ||
                  (isCDS && quantity >= 10) ||
                  loading == true ||
                  (isCDS && category.name == 'Limit Order 1 Piece')
                "
                class="ma-0 pa-0 mt-2 mb-2"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <v-btn
                v-if="product.categoryid != 10625 && !viewTransferPage"
                small
                fab
                outline
                :color="theme.color"
                :disabled="true"
                class="ma-0 pa-0 mt-2 mb-2"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <div
              class="small"
              style="color: red"
              v-if="isOutOfStock && !viewTransferPage"
            >
              {{ $t('Sold Out') }}
            </div>
            <div v-if="currentStock">
              <span
                class="caption"
                v-if="parseInt(currentStock[2]) + parseInt(adjust_qty) == 1"
              >
                ({{
                  $t('Only {item} item left', {
                    item: parseInt(currentStock[2]) + parseInt(adjust_qty)
                  })
                }})
              </span>
              <span
                class="caption"
                v-else-if="
                  parseInt(currentStock[2]) + parseInt(adjust_qty) > 0 &&
                  parseInt(currentStock[2]) + parseInt(adjust_qty) < 5
                "
              >
                ({{
                  $t('Only {item} items left', {
                    item: parseInt(currentStock[2]) + parseInt(adjust_qty)
                  })
                }})
              </span>
            </div>
            <!-- </div> -->
          </v-list-tile-sub-title>
        </v-flex>
        <v-flex xs2 sm2 class="text-xs-right" v-if="!viewTransferPage">
          <v-btn
            flat
            fab
            small
            :color="theme.color"
            @click="$emit('deleteItem')"
            :disabled="loading == true"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Nl2br from 'vue-nl2br'
import CheckBundle from '@/components/ecommerce/Bundles/CheckBundle'
import config from '@/config'
import axios from 'axios'
export default {
  props: [
    'viewTransferPage',
    'value',
    'stock',
    'loading',
    'categories',
    'isTero',
    'currentCategory'
  ],
  data() {
    return {
      product: this.value,
      quantity: this.value.quantity,
      adjust_qty: this.value.adjust_qty || 0
    }
  },
  components: {
    Nl2br,
    CheckBundle
  },
  computed: {
    ...mapGetters({
      isWholesale: 'getWholesaleStatus',
      wholesale: 'getWholesale',
      cart: 'getCart',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme',
      currencySign: 'currencySign',
      isThailandPostMart: 'isThailandPostMart'
    }),
    isKhaiwhan() {
      return (
        this.pageProfile &&
        this.$store.state.khaiwhan.includes(this.pageProfile.pageid)
      )
    },
    category() {
      if (this.isTero) {
        return { name: this.currentCategory }
      }
      return this.categories.find((el) => el.id == this.product.categoryid)
    },
    isCDS() {
      return (
        this.pageProfile &&
        this.$store.state.cds.includes(this.pageProfile.pageid)
      )
    },
    currentStock: function () {
      let vm = this

      if (this.isTero) {
        return [this.value.id, this.value.productStock.type, 999]
      }

      if (vm.stock.length == 0) {
        return null
      }

      let option = null
      option = vm.stock.find(function (val) {
        return (
          (vm.product.optionDetail && val[0] == vm.product.optionDetail[0]) ||
          (val[1] == vm.product.option.split(' - ')[0] &&
            ['khaiwhan', 'gaigao'].includes(vm.pageProfile.type))
        )
      })
      return option
    },
    isOutOfStock() {
      return (
        this.currentStock == null ||
        parseInt(this.currentStock[2]) + parseInt(this.adjust_qty) == 0 ||
        parseInt(this.currentStock[2]) + parseInt(this.adjust_qty) <
          this.quantity
      )
    },
    minimumQuantity() {
      return +this.value.minimum_order_quantity || 1
    },
    isYasale() {
      return this.pageProfile && this.pageProfile.type === 'yasale'
    }
  },
  watch: {
    value: {
      handler: function (newVal) {
        this.product = newVal
        this.quantity = newVal.quantity
        this.adjust_qty = newVal.adjust_qty || 0
      },
      deep: true
    }
  },
  methods: {
    deleteEmbroideredNameList(index) {
      this.product.addon_json.embroideredNameList.splice(index, 1)
      this.$emit('onChangeAddon', {
        ...this.product.addon_json
      })
    },
    async adjustReservedItem(type) {
      const vm = this
      try {
        const data = {
          userid: vm.$route.query.userid,
          sessiontoken: vm.$route.query.sessiontoken,
          productid: vm.product.id,
          option: vm.product.option,
          type: type,
          quantity: 1
        }
        if (vm.adjust_qty && vm.adjust_qty > 0) {
          const response = await axios.post(
            `${config.getConfig('serverUrl')}shop/${
              vm.pageProfile.pageid
            }/adjust-reserved-item`,
            data
          )

          return response.data
        }
      } catch (error) {
        if (error.response.data) {
          await vm.$swal({
            title: vm.$t(error.response.data.message),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('Cancel'),
            reverseButtons: true
          })
        }

        // eslint-disable-next-line no-console
        console.error(error)
      }
    },

    async checkAdjustAddCount() {
      const vm = this
      if (vm.adjust_qty && vm.adjust_qty > 0) {
        const res = await vm.adjustReservedItem('add')
        if (res.success) {
          vm.addCount()
        }
      } else {
        vm.addCount()
      }
    },

    addCount: async function () {
      try {
        let vm = this
        if (
          vm.quantity <
          parseInt(vm.currentStock[2]) + parseInt(this.adjust_qty)
        ) {
          if (this.isThailandPostMart) {
            await vm.$store.dispatch('addThailandPostMartCart', {
              product: { ...vm.product, quantity: 1 },
              userId: vm.$route.query.userid
            })
          }

          let quantity = 0
          try {
            quantity = parseInt(vm.quantity)
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error)
          }
          vm.quantity = quantity + 1
          vm.$set(vm.product, 'quantity', vm.quantity)
          vm.$store.dispatch('updateCartStock', {
            id: vm.product.id,
            quantity: vm.quantity,
            stockid: vm.currentStock[0]
          })
          vm.$emit('input', vm.product)
          vm.$emit('onUpdateStock')
        }
      } catch (error) {
        console.error(error)
      }
    },

    async checkAdjustRemoveCount() {
      const vm = this
      if (vm.adjust_qty && vm.adjust_qty > 0) {
        const res = await vm.adjustReservedItem('remove')
        if (res.success) {
          vm.removeCount()
        }
      } else {
        vm.removeCount()
      }
    },
    removeCount: async function () {
      try {
        let vm = this
        if (vm.quantity > 1) {
          if (this.isThailandPostMart) {
            await vm.$store.dispatch('removeThailandPostMartCart', {
              product: { ...vm.product, quantity: 1 },
              userId: vm.$route.query.userid
            })
          }

          vm.quantity -= 1
          vm.$set(vm.product, 'quantity', vm.quantity)
          vm.$store.dispatch('updateCartStock', {
            id: vm.product.id,
            quantity: vm.quantity,
            stockid: vm.currentStock[0]
          })
          vm.$emit('input', vm.product)
          vm.$emit('onUpdateStock')
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped></style>
